// extracted by mini-css-extract-plugin
module.exports =  {"horizontal-group":"_93444fe79c--horizontal-group--pefCW","vertical-group":"_93444fe79c--vertical-group--zi1Aj"};